import {ReactNode, useState} from 'react';

import {getRandomId} from 'shared/web';

import {AccountingCalculationCacheContext} from './AccountingCalculationCacheContext';

type AccountingCalculationCacheProviderProps = {
  children: ReactNode;
};

export function AccountingCalculationCacheProvider(props: AccountingCalculationCacheProviderProps) {
  const [value] = useState(() => ({
    taxDocumentCalculationCacheKey: getRandomId(),
    accountingDocumentCalculationCacheKey: getRandomId(),
  }));

  return (
    <AccountingCalculationCacheContext.Provider value={value}>
      {props.children}
    </AccountingCalculationCacheContext.Provider>
  );
}
